import {ActionCompletionDialogComponent} from '../common/action-completion-dialog/action-completion-dialog.component';
import {ActivatedRoute, Router} from '@angular/router';
import {AssignAndDetailModalComponent} from '../common/assign-and-detail-modal/assign-and-detail-modal.component';
import {AssignRequestComponent} from './assign-request/assign-request.component';
import {AuthService} from '../services/auth.service';
import {
  CancellationOrderDialogComponent
} from '../common/cancellation-order-dialog/cancellation-order-dialog.component';
import {CommonService} from '../services/common.service';
import {Component, OnInit} from '@angular/core';
import {ConfirmActionDialogComponent} from '../common/confirm-action-dialog/confirm-action-dialog.component';
import {ConfirmationDialogComponent} from '../repair-details/confirmation-dialog/confirmation-dialog.component';
import {
  EditReturnOrderSerialNumberComponent
} from '../common/edit-return-order-serial-number/edit-return-order-serial-number.component';
import {EventLogsService} from '../services/event-logs.service';
import {IReturnCommandDetails} from '../models/models';
import {LoadingService} from '../services/loading.service';
import {MatDialog, MatSnackBar} from '@angular/material';
import {PurchaseOrdersService} from '../services/purchase-orders.service';
import {RefrigeratorsService} from '../services/refrigerators.service';
import {SelectionModel} from '@angular/cdk/collections';
import {
  SimpleConfirmActionDialogComponent
} from '../common/simple-confirm-action-dialog/simple-confirm-action-dialog.component';
import {ToastMessagesService} from '../services/toast-messages.service';
import {
  UpdateSerialNumberDialogComponent
} from '../common/update-serial-number-dialog/update-serial-number-dialog.component';

@Component({
  styleUrls: ['./return-refrigerator-details.component.scss'],
  templateUrl: './return-refrigerator-details.component.html'
})
export class ReturnRefrigeratorDetailsComponent implements OnInit {
  public dataSource: IReturnCommandDetails[] = [];
  public displayedColumns: string[];
  public selection: SelectionModel<IReturnCommandDetails>;
  private model: string;
  private returnId: string;
  public returnDetails: any;
  public basicDetailsConfig: any;
  public showBasicInfo: boolean;
  private user: any;
  private canSeeActions = false;
  pageInitialized: boolean;

  constructor(private activatedRoute: ActivatedRoute,
              private authService: AuthService,
              private commonService: CommonService,
              private eventLogsService: EventLogsService,
              private loadingService: LoadingService,
              private matDialog: MatDialog,
              private matSnackBar: MatSnackBar,
              private purchaseOrdersService: PurchaseOrdersService,
              private refrigeratorsService: RefrigeratorsService,
              private router: Router,
              private toastMessagesService: ToastMessagesService) {
    this.pageInitialized = false;
    this.model = 'return_command/web/details';
    this.selection = new SelectionModel<IReturnCommandDetails>(true, []);
    // this.returnDetails = JSON.parse(localStorage.getItem('returnDetails'));
    // if (!this.returnDetails) {
    //   this.returnDetails = null;
    // }

    this.showBasicInfo = false;

  }

  public async ngOnInit(): Promise<any> {
    this.activatedRoute.params.subscribe(async (params) => {
      this.returnId = params.id;
      const logs = await this.eventLogsService.getRefrigeratorEventLogs('return_refrigerator_details', +this.returnId);

      const parentRowRequest = await this.commonService.getListWithParameters(`return_command/web`, `id=${+params.id}`);
      const row = parentRowRequest[0];

      this.returnDetails = {
        created_from_user_role_id: row.role_id,
        created_from_user_role_name: row.role_name,
        requestId: row.id,
        status_id: row.status_id,
        city: row.recipient_sale_point_city,
        recipient_id: row.recipient_user_id,
        recipient: row.recipient_sale_point_customer_name,
        typeId: row.type_id,
        cancel_reason_description: row.cancel_reason_description,
        cancel_reason_id: row.cancel_reason_id,
        applicant_name: row.applicant_sale_point_customer_name ? row.applicant_sale_point_customer_name : '-',
        applicant_sales_group: row.applicant_sale_point_sales_group ? row.applicant_sale_point_sales_group : '-',
        applicant_address: row.applicant_sale_point_address ? row.applicant_sale_point_address : '-',
        recipient_sales_group: row.recipient_sales_group ? row.recipient_sales_group : '-',
        comments: row.comments ? row.comments : '-',
        return_reason_name: row.return_reason_name ? row.return_reason_name : '-'
      };

      const data: IReturnCommandDetails[] = await this.purchaseOrdersService.getList(`${this.model}`,
        `return_command_id=${this.returnId}`, false);


      data.forEach(detail => {
        this.returnDetails.status_id = detail.command_status_id;
        this.returnDetails.typeId = detail.command_type_id;
        detail.is_confirmed_desc = detail.is_confirmed === 1 ? '√' : 'X';
        detail.is_received_desc = detail.is_received === 1 ? '√' : 'X';
        detail.is_withdrawn_desc = detail.is_withdrawn === 1 ? '√' : 'X';
        this.returnDetails.city = data[0].recipient_sale_point_city ? data[0].recipient_sale_point_city : '-';
        this.returnDetails.recipient = data[0].recipient_sale_point_customer_name ? data[0].recipient_sale_point_customer_name : '-';
      });

      if (this.returnDetails.status_id === 5) {
        this.displayedColumns = ['select', 'serial_number', 'material_id', 'material_description', 'is_confirmed_desc', 'is_received_desc', 'is_withdrawn_desc', 'latitude', 'longitude'];
      } else {
        this.displayedColumns = ['serial_number', 'material_id', 'material_description', 'is_confirmed_desc', 'is_received_desc', 'is_withdrawn_desc', 'latitude', 'longitude'];
      }

      if (this.returnDetails.typeId === 6) {
        this.displayedColumns.push('sales_inspector_action_description');
      }

      this.displayedColumns.push('actions');

      this.dataSource = data;
      this.loadingService.hide();
      await this.initUser();
      this.pageInitialized = true;

    });
  }


  private async initUser() {
    this.user = await this.authService.getUser();
    this.initBasicInfo();
    await this.CanShowActions();
  }

  private async initBasicInfo() {
    this.showBasicInfo = true;
    this.basicDetailsConfig = {
      showActions: this.CanShowActions(),
      subtitle: [
        {
          title: 'Αριθμός Εντολής Επιστροφής',
          value: this.returnId
        }
      ],
      title: 'Πληροφορίες Εντολής Επιστροφής'
    };

    this.initializeActions();
  }

  private initializeActions(): void {
    const actions = [];
    const action = {
      function: () => {
        this.initializeCreateAssignment();
      },
      showAction: this.returnDetails.status_id === 6,
      title: 'Ανάθεση Εντολής Επιστροφής σε χρήστη',
      icon: 'assignment',
      color: 'black'
    };
    const action1 = {
      function: () => {
        this.initializeCreateAssignment();
      },
      showAction: this.returnDetails.status_id === 10,
      title: 'Ενημέρωση ανάθεσης Εντολής Επιστροφής σε χρήστη',
      icon: 'assignment',
      color: 'black'
    };

    const action2 = {
      function: async () => {
        await this.initializeConfirmCancellationDialog(this.returnDetails);
      },
      showAction: this.canShowCancelAction(),
      title: 'Διαγραφή Εντολής Επιστροφής',
      icon: 'cancel',
      color: 'red'
    };

    const action3 = {
      function: () => {
        this.downloadPDF();
      },
      showAction: true,
      title: 'Λήψη PDF',
      icon: 'picture_as_pdf',
      color: '#013e81',
    };

    const action4 = {
      function: () => {
        this.cancelCompleteOrder();
      },
      showAction: this.isCancelButtonEnabled(),
      title: 'Ακύρωση εντολής επιστροφής',
      icon: 'block',
      color: '#013e81',
    };


    if (this.user.role_id === 1 || this.user.role_id === 10 || this.user.role_id === 11) {
      actions.push(action);
      actions.push(action1);
      actions.push(action2);
      actions.push(action3);
      actions.push(action4);
    } else if (this.user.role_alternate_name === 'hqManager') {
      actions.push(action3);
    } else {
      actions.push(action);
      actions.push(action1);
      actions.push(action2);
      actions.push(action3);
    }

    if (actions.length > 0) {
      this.basicDetailsConfig.actions = actions;
      this.basicDetailsConfig.showActions = true;
    } else {
      this.basicDetailsConfig.showActions = false;
    }

  }


  isCancelButtonEnabled(): boolean {
    if (this.returnDetails.status_id === 3 || this.returnDetails.status_id === 4 || this.returnDetails.status_id === 9) {
      return false;
    } else {
      for (const record of this.dataSource) {
        if (record.is_received === 1) {
          return false;
        }
      }
    }
    return true;

  }

  cancelCompleteOrder() {
    const dialog = this.matDialog.open(CancellationOrderDialogComponent, {
      width: '650px',
      data: {
        title: `Ακύρωση εντολής επιστροφής με αριθμό ${this.returnId}`,
        mode: 0,
        id: this.returnId
      }
    });

    dialog.afterClosed().subscribe(result => {
      if (result) {
        this.toastMessagesService.toastMessages('Η ακύρωση ολοκληρώθηκε με επιτυχία');
      }
    });
  }

  private canShowCancelAction() {
    if (this.returnDetails.status_id === 1) {
      return true;
    }

    // tslint:disable-next-line:max-line-length
    if ((this.returnDetails.status_id === 6 && (this.returnDetails.typeId === 10 || this.returnDetails.typeId === 14))
      || (this.returnDetails.status_id === 5 && this.returnDetails.typeId === 5)) {
      return true;
    }

    if (this.returnDetails.status_id === 5 && this.returnDetails.created_from_user_role_id === 4 && this.returnDetails.typeId === 6) {
      return true;
    }
  }

  private async initializeConfirmCancellationDialog(details) {
    const cancellationDialog = this.matDialog.open(ConfirmationDialogComponent, {
      data: {
        message: `Είστε σίγουροι ότι θέλετε να διαγράψετε την εντολή επιστροφής με αριθμό ${details.requestId};`,
        title: 'Διαγραφή Εντολής Επιστροφής'
      }
    });


    cancellationDialog.afterClosed().subscribe(async (response) => {
      if (response) {
        await this.cancelRequest(details);
      }
    });
  }

  private async cancelRequest(details) {
    try {
      await this.commonService.deleteItem(`return_command/web`, details.requestId);
      this.toastMessagesService.toastMessages('Η διαγραφή ολοκληρώθηκε με επιτυχία');
      await this.router.navigate(['returns']);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  private async CanShowActions() {
    const canUserSeeAction = await this.commonService.showActions(this.user);

    this.canSeeActions = canUserSeeAction && this.returnDetails.status_id === 6;
  }

  async downloadPDF() {
    try {
      await this.commonService.getPDF(`pdf?model=return_command&id= ${this.returnId}`, `Εντολή Επιστροφής - ${this.returnId}`);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  private async initializeCreateAssignment() {
    // this.loadingService.show();
    let filter = '';
    if (this.returnDetails.typeId === 5) {
      filter = 'role_id=13 OR role_id=14';
    } else {
      filter = 'role_id=14';
    }

    const users = await this.commonService.getListWithParameters('user', filter);
    this.loadingService.hide();
    this.matDialog.open(AssignRequestComponent, {
      data: {
        users,
        typeId: this.dataSource[0].command_type_id,
        requestId: this.returnDetails.requestId,
        userRouted: this.returnDetails.recipient_id ? this.returnDetails.recipient_id : null
      }
    });
  }

  public getRecord(row): void {
    this.matDialog.open(AssignAndDetailModalComponent, {
      data: {
        row,
        orderId: this.returnDetails.requestId,
        refrigeratorId: row.id,
        type: 0,
        serial_number: row.serial_number
      }
    });
  }

  public isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;

    const numRows = this.dataSource.length;

    return numSelected === numRows;
  }

  public confirmCompletion(): void {
    this.matDialog.open(ConfirmActionDialogComponent, {
      data: {
        confirmFunction: async () => {
          await this.completeCommand({returnId: this.returnId});
        },
        message: 'Είστε σίγουροι ότι θέλετε να θέσετε την εντολή ως ολοκληρωμένη;',
        title: 'Ολοκλήρωση Εντολής Επιστροφής'
      }
    });
  }

  public isCompletionOpen(): boolean {
    if (this.user && this.user.role_alternate_name !== 'hqManager') {
      return this.returnDetails.status_id === 3 && (this.returnDetails.typeId === 14 || this.returnDetails.typeId === 5
        || this.returnDetails.typeId === 6 || this.returnDetails.typeId === 10 || this.returnDetails.typeId === 11);
    } else {
      return false;
    }
  }

  public async completeCommand(object) {
    try {
      await this.purchaseOrdersService.updateReceiptCommand(`return_command/web/completion/${object.returnId}`, {});
      this.matDialog.open(ActionCompletionDialogComponent, {
        data: {
          buttonText: 'Πλοήγηση στις επιστροφές ψυγείων',
          redirectURL: `returns`
        }
      });
    } catch (e) {
    }
  }


  public async confirmDisapproval() {
    const items = [];
    this.selection.selected.forEach(selectedItem => {
      const model = {
        id: selectedItem.id,
      };
      items.push(model);
    });
    const message = items.length > 0 ? 'Είστε σίγουροι ότι θέλετε να εγκρίνετε τα επιλεγμένα ψυγεία;' : 'Είστε σιγουροι ότι θέλετε να ακυρώσετε ολόκληρη την εντολή;';
    const title = items.length > 0 ? 'Έγκριση ψυγείων' : 'Ακύρωση εντολής';
    this.matDialog.open(ConfirmActionDialogComponent, {
      data: {
        confirmFunction: () => {
          this.disapproveRequest({returnId: this.returnId, items});
        },
        message,
        title
      }
    });
  }

  public async disapproveRequest(object: any) {
    try {
      await this.purchaseOrdersService.updateReceiptCommand(`return_command/web/approval/${object.returnId}`, object.items);
      const route = this.router.url;
      this.router.navigated = false;
      this.router.navigate([route]);

      // this.matDialog.open(ActionCompletionDialogComponent, {
      //   data: {
      //     buttonText: 'Πλοήγηση στις επιστροφές ψυγείων',
      //     redirectURL: `returns`
      //   }
      // });
    } catch (e) {
    }
  }

  public masterToggle(): void {
    this.isAllSelected() ? this.selection.clear() : this.dataSource.forEach((row) => this.selection.select(row));
  }

  async updateRefrigerator(element: any, edit: boolean) {
    const type = 3;
    if (edit) {
      const dialogResult = this.matDialog.open(UpdateSerialNumberDialogComponent, {});

      dialogResult.afterClosed().subscribe(async (serialNumber) => {
        if (serialNumber) {
          const model = {} as UpdateEntities;
          model.type = type;
          model.id = element.id;
          model.value = serialNumber;

          try {
            await this.refrigeratorsService.updateRefrigeratorSerialNumber(model);
            this.toastMessages(`H ενημέρωση ολοκληρώθηκε με επιτυχία`);
            element.refrigerator_type_id = 4;
            element.serial_number = serialNumber;
          } catch (e) {
            this.toastMessages(`H ενημέρωση απέτυχε. Λόγος: ${e.message}`);
          }
        }
      });
    } else {
      const dialogResult = this.matDialog.open(SimpleConfirmActionDialogComponent, {
        data: {
          title: 'Ενημέρωση σειριακού αριθμού',
          message: `Είστε σίγουροι ότι ενημερώσατε τις πληροφορίες του ψυγείου για το σειριακό αριθμό : ${element.serial_number};`
        }
      });

      dialogResult.afterClosed().subscribe(async (result) => {
        if (result) {
          const model = {} as UpdateEntities;
          model.type = type;
          model.id = element.id;
          model.value = element.serial_number;
          try {
            await this.refrigeratorsService.updateRefrigeratorSerialNumber(model);
            element.refrigerator_type_id = 4;
            this.toastMessages(`H ενημέρωση ολοκληρώθηκε με επιτυχία`);
          } catch (e) {
            this.toastMessages(`H ενημέρωση απέτυχε. Λόγος: ${e.message}`);
          }
        }
      });
    }
  }

  async updateSerialNumber(element: any, edit: boolean) {
    const model = {
      newSerialNumber: element.serial_number,
      id: element.id
    };
    const editDialog = this.matDialog.open(EditReturnOrderSerialNumberComponent, {
      width: '400px',
      height: '300px',
      disableClose: true,
      data: {
        title: 'Επεξεργασία σειριακού αριθμού',
        details: model
      }
    });

    editDialog.afterClosed().subscribe(result => {
      if (result) {
        this.toastMessagesService.toastMessages('Η επεξεργασία του σειριακού ολοκληρώθηκε με επιτυχία');
      }
    });

  }


  toastMessages(message: string): void {
    this.matSnackBar.open(message, null, {
      duration: 3000
    });
  }

  cancelRow(element) {
    const dialog = this.matDialog.open(CancellationOrderDialogComponent, {
      width: '650px',
      data: {
        title: `Ακύρωση εντολής επιστροφής ψυγείου με αριθμό ${element.id}`,
        mode: 1,
        id: element.id,
        serial_number: element.serial_number,
        command_id: this.returnId
      }
    });

    dialog.afterClosed().subscribe(result => {
      if (result) {
        this.toastMessagesService.toastMessages('Η ακύρωση ολοκληρώθηκε με επιτυχία');
      }
    });
  }

  isCancelAtRowDisabled(row): boolean {
    if (this.returnDetails.status_id === 3 || this.returnDetails.status_id === 4 || this.returnDetails.status_id === 9) {
      return true;
    } else {
      if (row.is_received === 0 && row.is_canceled === 0) {
        return false;
      } else {
        return true;
      }
    }

    return false;


  }

  isEditAtRowDisabled(): boolean {
    return this.returnDetails.status_id === 4 || this.returnDetails.status_id === 9;
  }

  isUserInRole() {
    return this.user.role_id === 1 || this.user.role_id === 10;
  }

  isUserInRole1() {
    return this.user.role_id === 1 || this.user.role_id === 10 || this.user.role_id === 11;
  }
}
